/**
 * מזהה מוצר אחיד להשוואת סל ↔ מוצר (מחרוזת, ObjectId, { $oid }, אובייקט עם _id).
 */
export function normalizeProductId(val) {
  if (val == null || val === "") return "";
  if (typeof val === "string" || typeof val === "number") return String(val).trim();
  if (typeof val === "object") {
    if (val.$oid != null) return String(val.$oid);
    if (val._id != null) return normalizeProductId(val._id);
    if (val.id != null) return normalizeProductId(val.id);
  }
  try {
    const s = String(val);
    if (s !== "[object Object]") return s;
  } catch {
    /* ignore */
  }
  return "";
}

/** מזהה מוצר מתוך שורת סל */
export function cartItemProductId(item) {
  if (!item) return "";
  const emb = item.product_id && typeof item.product_id === "object" ? item.product_id : null;
  return normalizeProductId(
    emb?._id ?? emb?.id ?? item.product_id?._id ?? item.product_id?.id ?? item.product_id
  );
}

/** מוצא פריט בסל לפי מק״ט (product _id) בלבד — לא לפי ברקוד */
export function findCartItemByProductId(cartItems, productOrId) {
  if (!Array.isArray(cartItems) || !cartItems.length) return null;
  const pid = normalizeProductId(
    productOrId != null && typeof productOrId === "object"
      ? productOrId.id ?? productOrId._id
      : productOrId
  );
  if (!pid) return null;
  return cartItems.find((item) => cartItemProductId(item) === pid) ?? null;
}

export function cartQtyForProductId(cartItems, productOrId) {
  const found = findCartItemByProductId(cartItems, productOrId);
  return found ? Number(found.quantity) || 0 : 0;
}
